import { __generator } from "tslib";
import { all, call, put, select, takeEvery, takeLatest, } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { actions as modalActions } from '../../Modals';
import { selectors, withOffset } from '../../Stream';
import { fetchBackgrounds, saveBackground, saveBackgroundFail, saveBackgroundSuccess, showBackgroundPicker, initializeBackgrounds, setBackground, } from './actions';
import { canUserSetBackground, getCurrentBackgroundId } from './selectors';
import { backgroundsStreamId, streamType } from './constants';
import { doFetchBackgrounds, doSetBackground } from './xhr';
import { ModalType } from '../../Modals/redux/types';
import { getIsCurrentUserAuthorOf } from '../../redux/deviations/selectors';
import { unloadDuperbrowseItem, exitDuperbrowse, shutdownDuperbrowse, } from '../../Duperbrowse/redux/actionCreators';
var logger = ddt.createLogger('devbgs');
function handleStreamFetch(_a) {
    var streamParams;
    var streamId = _a.streamId;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(selectors.getStreamParams, streamId)];
            case 1:
                streamParams = _b.sent();
                if (!streamParams) {
                    return [2 /*return*/];
                }
                if (!(streamParams.type === streamType)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(fetchBackgrounds())];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}
function handleFetchBackgrounds(action) {
    var _a, offset, limit, result;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(function (state) { return ({
                    offset: withOffset.selectors.getNextOffset(state, backgroundsStreamId),
                    limit: selectors.getItemsPerFetch(state, backgroundsStreamId),
                }); })];
            case 1:
                _a = _b.sent(), offset = _a.offset, limit = _a.limit;
                return [4 /*yield*/, call(doFetchBackgrounds, offset, limit)];
            case 2:
                result = _b.sent();
                if (!!result) return [3 /*break*/, 4];
                logger.log('Failed to fetch backgrounds', result);
                return [4 /*yield*/, put(withOffset.actions.fetchFailure({
                        streamId: backgroundsStreamId,
                        errorMsg: 'Failed to fetch',
                    }))];
            case 3:
                _b.sent();
                return [2 /*return*/];
            case 4: return [4 /*yield*/, put(withOffset.actions.fetchSuccessDeduped({
                    streamId: backgroundsStreamId,
                    items: result.results,
                    hasMore: !!result.hasMore,
                    nextOffset: result.nextOffset,
                }))];
            case 5:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function handleSaveBackground(_a) {
    var backendBackgroundId, canSetBackground, originalBackgroundId, result;
    var _b = _a.payload, deviation = _b.deviation, backgroundId = _b.backgroundId;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                backendBackgroundId = backgroundId < 0 ? undefined : backgroundId;
                return [4 /*yield*/, select(canUserSetBackground, backgroundId)];
            case 1:
                canSetBackground = _c.sent();
                if (!canSetBackground) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getCurrentBackgroundId, deviation)];
            case 2:
                originalBackgroundId = _c.sent();
                return [4 /*yield*/, put(setBackground(deviation.deviationId, backgroundId))];
            case 3:
                _c.sent();
                return [4 /*yield*/, call(doSetBackground, deviation.deviationId, backendBackgroundId)];
            case 4:
                result = _c.sent();
                if (!(!result || result.errorDescription)) return [3 /*break*/, 6];
                logger.error('Failed to set background', result && result.errorDescription);
                return [4 /*yield*/, all([
                        put(saveBackgroundFail(deviation.deviationId, backgroundId)),
                        put(setBackground(deviation.deviationId, originalBackgroundId)),
                    ])];
            case 5:
                _c.sent();
                return [2 /*return*/];
            case 6: return [4 /*yield*/, put(saveBackgroundSuccess(deviation.deviationId, backgroundId))];
            case 7:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function handleShowPicker(_a) {
    var isOwner;
    var deviation = _a.payload.deviation;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getIsCurrentUserAuthorOf, deviation)];
            case 1:
                isOwner = _b.sent();
                if (!isOwner) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, all([
                        call(handleInitializeBackgrounds),
                        put(modalActions.pushModal(ModalType.DEVIATION_BACKGROUND_PICKER, {
                            wrapInModal: false,
                            params: {
                                deviation: deviation,
                            },
                        })),
                    ].filter(function (x) { return x; }))];
            case 2:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function handleUnloadDuper() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(modalActions.removeModalsOfType(ModalType.DEVIATION_BACKGROUND_PICKER))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleInitializeBackgrounds() {
    var existingStreamParams, streamParams;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(selectors.getStreamParams, backgroundsStreamId)];
            case 1:
                existingStreamParams = _a.sent();
                if (existingStreamParams && existingStreamParams.type === streamType) {
                    return [2 /*return*/];
                }
                streamParams = {
                    type: streamType,
                };
                return [4 /*yield*/, put(withOffset.actions.initialize({
                        streamId: backgroundsStreamId,
                        itemsPerFetch: 24,
                        items: [],
                        hasMore: true,
                        streamParams: streamParams,
                    }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default function backgroundsRootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(initializeBackgrounds, handleInitializeBackgrounds),
                    takeEvery(withOffset.actions.STREAM__WITH_OFFSET__FETCH, handleStreamFetch),
                    takeLatest(fetchBackgrounds, handleFetchBackgrounds),
                    takeEvery(saveBackground, handleSaveBackground),
                    takeEvery(showBackgroundPicker, handleShowPicker),
                    takeEvery([unloadDuperbrowseItem, exitDuperbrowse, shutdownDuperbrowse], handleUnloadDuper),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map